var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 13c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 13c.82843 0 1.5-.6716 1.5-1.5s-.67157-1.5-1.5-1.5-1.5.6716-1.5 1.5.67157 1.5 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9999 19c-2.07003 0-3.56103-1.168-3.62303-1.218-.432-.344-.503-.973-.159-1.405.343-.43.969-.503 1.401-.163.026.02 1.03903.786 2.38103.786 1.353 0 2.372-.778 2.382-.786.434-.336 1.062-.262 1.402.17s.27 1.055-.161 1.398c-.062.05-1.553 1.218-3.623 1.218z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.6e89b25c64b36574c6012fa55d2eee55.svg";
export { ForwardRef as ReactComponent };